<template>
  <v-card>
    <v-card-title>
      <v-layout row>
        <span class="headline mb-0">B/L #{{ sa.blNo }}</span>
        <span class="ml-2 pt-2">{{ sa.status }}</span>
        <v-spacer />
        <span>{{ sa.transportModeCode }}</span>
        <span class="ml-4">{{ sa.incotermCode }}</span>
        <span class="ml-4"
          >{{ sa.loadingPortCode }}:{{ sa.loadingPortName }}</span
        >
        <span class="ml-2">→</span>
        <span class="ml-2"
          >{{ sa.dischargePortCode }}:{{ sa.dischargePortName }}</span
        >
      </v-layout>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="sa.packages"
      :loading="loading"
      hide-actions
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <td width="150">{{ props.item.invoiceNo }}</td>
        <td :style="diffStyle('poNo', props.item)" width="150">
          {{ props.item.poNo }}
        </td>
        <td width="200">
          {{ props.item.productCode }}:{{ props.item.productName }}
        </td>
        <td width="200">{{ props.item.skuCode }}</td>
        <td width="100">{{ props.item.paid ? '有償' : '無償' }}</td>
        <td width="100">
          {{ props.item.cartonStartNo }}-{{ props.item.cartonEndNo }}
        </td>
        <td width="100">{{ props.item.perCartonQty }}</td>
        <td :style="diffStyle('qty', props.item)" width="100">
          {{ props.item.totalQty }}
        </td>
        <td width="100">{{ props.item.currencyCode }}</td>
        <td :style="diffStyle('unitPrice', props.item)" width="100">
          {{ props.item.unitPrice }}
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: ['id', 'conflictId'],
  data() {
    return {
      form: {},
      status: { NORMAL: '', CONFLICT: 'PO变更', CANCEL: 'PO取消' },
      headers: [
        { text: 'INV NO', value: 'invNo', sortable: false },
        { text: 'P/O NO', value: 'poNo', sortable: false },
        { text: '品種', value: 'productName', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        { text: '有償/無償', value: 'paid', sortable: false },
        { text: 'Carton', value: 'carton', sortable: false },
        { text: '入り数', value: 'perCartonQty', sortable: false },
        { text: '数量', value: 'totalQty', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: '単価', value: 'unitPrice', sortable: false },
      ],
      sa: {},
      loading: false,
      conflictType: 'UNKNOWN',
      conflictFields: [],
    }
  },
  methods: {
    diffStyle(prop, item) {
      if (this.poNo === item.poNo && this.conflictFields.indexOf(prop) !== -1)
        return 'color: red; font-weight: bold; font-size: 16px'
      return ''
    },
    highlight(type, fields) {
      this.conflictType = type || 'UNKNOWN'
      this.conflictFields = fields || []
    },
  },
  mounted() {
    this.loading = true

    if (this.id) {
      this.$http.get(`/shipping-advices/${this.id}`).then((res) => {
        this.sa = res.data
        // this.results.forEach(sa =>
        //   sa.packages.sort((a, b) => (b.poNo || '').localeCompare(a.poNo || ''))
        // )
        this.loading = false
      })
    }
    if (this.conflictId) {
      this.$http
        .get(`/shipping-advices/formal/${this.conflictId}`)
        .then((res) => {
          this.sa = res.data
          // this.results.forEach(sa =>
          //   sa.packages.sort((a, b) => (b.poNo || '').localeCompare(a.poNo || ''))
          // )
          this.loading = false
        })
    }
  },
  computed: {},
}
</script>
